import React from 'react'

import Wrapper from './src/components/Wrapper'
import 'gatsby-theme-directv/global.css'

export const wrapPageElement = ({ element, props }) => {
  const theme = props.pageContext.customTheme
  return <Wrapper customTheme={theme}>{element}</Wrapper>
}
